import React, { useEffect } from "react";
import Checklist from "./ChecklistInLead";
import { getHidedChecklistsBySettings } from "../../api/checklists";
import { getCurrLeadId } from "../../amo/leads";
import { useChecklistsState } from "../../state/checklistsState";
import { backfillCustomFieldFromAmo } from "../../services/checklistService";

const ChecklistsContainer = ({ status }) => {
    const { 
        checklists, 
        setChecklists,
        hiddenChecklists,
        setHiddenChecklists,
        refreshAmoPrerequisiteState
    } = useChecklistsState();

    useEffect(() => {
        setChecklists(status.checklists);
    }, [status]);

    useEffect(() => {
        getHidedChecklistsBySettings(getCurrLeadId(), status.amo_status_id)
            .then((data) => {
                setHiddenChecklists(data);
            });
    }, [status]);

    useEffect(() => {
        if (!checklists || checklists.length === 0) return;
        (async () => {
            for (const cl of checklists) {
                if (!cl?.custom_fields || cl.custom_fields.length === 0) continue;
                for (const cf of cl.custom_fields) {
                    try {
                        await backfillCustomFieldFromAmo(cl.id, cf);
                    } catch (e) {
                        console.error(e);
                    }
                }
            }
        })();
    }, [checklists]);

    useEffect(() => {
        let refreshTimeout = null;
        const handleAmoFieldInput = () => {
            if (refreshTimeout) {
                clearTimeout(refreshTimeout);
            }
            refreshTimeout = setTimeout(() => {
                refreshAmoPrerequisiteState();
            }, 100);
        };

        document.addEventListener("input", handleAmoFieldInput, true);
        document.addEventListener("change", handleAmoFieldInput, true);

        return () => {
            if (refreshTimeout) {
                clearTimeout(refreshTimeout);
            }
            document.removeEventListener("input", handleAmoFieldInput, true);
            document.removeEventListener("change", handleAmoFieldInput, true);
        };
    }, [refreshAmoPrerequisiteState]);

    return (
        <div>
            {checklists
                .filter(c => !c.parent)
                .sort((a, b) => a.position - b.position)
                .map((checklist) => (
                    <Checklist 
                        key={checklist.id} 
                        checklist={{...checklist, status_id: status.amo_status_id}}
                    />
                ))}
        </div>
    );
};

export default ChecklistsContainer;
